module.exports = __webpack_public_path__ + "static/media/远程自助打印.96fe160.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SelfPrinting/远程自助打印.mp4
// module id = XRd1
// module chunks = 10